export enum WidgetType {
  Location = 1,
  Time = 2,
  Status = 3,
  MapLegend = 4,
  AlertFeed = 5,
  Image = 6
}
